module.exports = __webpack_public_path__ + "static/media/save.f83b744a.svg";